import { render } from "./ReferralComp.vue?vue&type=template&id=541f2020&scoped=true"
import script from "./ReferralComp.vue?vue&type=script&lang=js"
export * from "./ReferralComp.vue?vue&type=script&lang=js"

import "./ReferralComp.vue?vue&type=style&index=0&id=541f2020&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541f2020"]])

export default __exports__